import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableDiagramProdMode } from '@rxzu/angular';

import { environment } from './environments/environment';
import { AppModule } from './app/app.module';

if (environment.production) {
  enableDiagramProdMode();
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
